/**
 * @file main.jsx
 * @description Application entry point. Renders the root React component
 * with React Query, Wishlist context, and web vitals reporting.
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import { WishlistProvider } from './Context/WishlistContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { reportWebVitals, sendToAnalytics } from './utils/analytics';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
      retry: 1,
      refetchOnReconnect: true,
    },
  },
});

createRoot(document.getElementById('root')).render(
  <QueryClientProvider client={queryClient}>
    <WishlistProvider>
      <App />
    </WishlistProvider>
  </QueryClientProvider>
);

// Report web vitals
reportWebVitals(sendToAnalytics);
